<template>
    <div class="input-wrapper">
        <label class="base-label" v-if="label">{{label}}</label>
        <input class="base-input"
            v-bind="{
                    ...$attrs,
                    onInput: (event)=>$emit('update:modelValue',event.target.value)
                }"
            :value="modelValue"
               :placeholder="placeholder"
               :autocomplete="autocomplete"
        />
    </div>
</template>

<script>
    export default {
        name: "BaseInput",
        emits: ['update:modelValue'],
        props: {
            modelValue: {
                type:[String, Number],
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            autocomplete: {
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                default: ''
            },
            emptyImage: {
                type: String,
                default: ''
            }
        }
    }
</script>
